/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import classNames from 'classnames';
import { Typography } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import DirectionsCarIcon from '@material-ui/icons/DirectionsCar';
import RoomIcon from '@material-ui/icons/Room';
import { startEndTimeDisplay, parseDateUtc } from '../../../../utils/dates';
import globals from '../../../../globals/communityGlobals';

export default function NonPatientActivity({
  assignment,
  containerClass,
  schedulerPeriod,
  flags,
  handleNonPatientActivityClick,
}) {
  const time =
    flags.isCompletedVisit || flags.isAhead
      ? assignment.actualOccurance.visual
      : flags.isClinicianRowActive
      ? assignment.visitTime.visual
      : assignment.totalTime.visual;
  const showContent = time.duration > 5;
  const hasVisualTravelDuration =
    flags.showTravelTime &&
    assignment.travelTime.visual.duration > 0 &&
    !flags.isClinicianRowActive &&
    !flags.isBehindNow &&
    !flags.isCompletedVisit &&
    !flags.isAhead;
  const showPatientAssignmentContent =
    showContent &&
    (flags.showTravelTime
      ? parseDateUtc(assignment.visitTime.actual.startDate).isBefore(schedulerPeriod.endDate)
      : true);

  const contentClass = classNames('visit-content', {
    'visit-empty-content': !showPatientAssignmentContent && !flags.isBehindNow && time.duration >= 10,
  });

  const minDuration = assignment.totalTime.visual.duration > 5 ? assignment.totalTime.visual.duration : 5;
  const isNPAWithTravel = assignment.postcode !== '' && assignment.postcode !== null;
  const isNpaInFuture = parseDateUtc(assignment.visitTime.actual.startDate).isSameOrAfter(
    parseDateUtc(globals.now),
    'day',
  );

  return (
    <div
      key={`npa_${assignment.index}`}
      className={containerClass}
      data-start-datetime={assignment.totalTime.visual.startDate}
      data-duration={minDuration}
    >
      {showContent && hasVisualTravelDuration && (
        <Box
          className="visit-travel-section"
          data-duration={assignment.travelTime.visual.duration}
          display="flex"
          justifyContent="center"
          alignItems="center"
          onClick={() => handleNonPatientActivityClick(assignment)}
        >
          <Box>
            <DirectionsCarIcon fontSize="small" />
            <Typography variant="subtitle2" display="block">
              {`${assignment.travelTime.actual.duration} min`}
            </Typography>
          </Box>
        </Box>
      )}
      <div className={contentClass} onClick={() => handleNonPatientActivityClick(assignment)}>
        {time.duration <= 5 && (
          <Box className="npa-vertical-content" display="flex">
            <Typography className="ellipsis" variant="h5">
              NPA
            </Typography>
            <Typography variant="subtitle2" display="block">
              {`  ${time.duration} min`}
            </Typography>
          </Box>
        )}
        {showContent && (
          <React.Fragment>
            <Typography className="ellipsis" variant="subtitle2">
              {assignment.secondaryLabel}
            </Typography>
            <Typography className="ellipsis" variant="h5">
              {assignment.primaryLabel}
            </Typography>
            <Typography className="ellipsis" variant="subtitle2">
              {startEndTimeDisplay(assignment.totalTime.actual.startDate, assignment.totalTime.actual.endDate)}
            </Typography>
            {isNPAWithTravel ? (
              <Typography className="ellipsis with-line-height" variant="subtitle2">
                <RoomIcon fontSize="small" />
                {assignment.postcode}
              </Typography>
            ) : (
              <React.Fragment />
            )}
          </React.Fragment>
        )}
      </div>
    </div>
  );
}
